<template>
  <el-tree-select
    v-model="selectValue"
    :data="selectOptions"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :filterable="filterable"
    :clearable="clearable"
    :check-strictly="true"
    @change="onChange"
  ></el-tree-select>
</template>

<script>
import {
  createVNode,
  defineComponent,
  onMounted,
  toRefs,
  getCurrentInstance,
  reactive,
  ref,
  watch,
} from "vue";
import { replaceObjectKeys } from "@pansy/utils";
import selectMixin from "./selectMixin";

export default defineComponent({
  name: "sTreeSelect",
  mixins: [selectMixin],
  props: {},
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      selectOptions: [],
      selectValue: null,
    });

    // 获取下拉选项
    const getData = (obj) => {
      if (props.url) {
        proxy.$api[props.url]({ ...props.params, ...obj }).then((res) => {
          let data = res.data ? res.data : res;
          state.selectOptions = props.field
            ? replaceObjectKeys(data, props.field, {
                simplify: false,
              })
            : data;
        });
      } else if (props.options && props.options.length > 0) {
        state.selectOptions = props.field
          ? replaceObjectKeys(props.options, props.field)
          : props.options;
      }
    };

    onMounted(() => {
      state.selectValue = props.modelValue
        ? props.modelValue
        : props.multiple
        ? []
        : "";
      getData();
    });

    watch(
      () => props.modelValue,
      (n) => {
        if (props.multiple) {
          state.selectValue = n ? (n instanceof Array ? n : n.split(",")) : [];
        } else {
          state.selectValue = n;
        }
      }
    );

    watch(
      () => props.params,
      (n) => {
        getData();
      }
    );
    watch(
      () => props.options,
      (n) => {
        if (!props.url) {
          getData();
        }
      }
    );

    const onChange = (value, option) => {
      emit("update:modelValue", state.selectValue);
      emit("change-check", value, option);
    };

    return {
      ...toRefs(state),
      onChange,
      getData,
    };
  },
});
</script>
<style lang="less">
.g-select {
  &.ant-select {
    width: 218px;
  }
}
</style>
